import {DataObjectId} from 'yougile-model'
import {EventBus} from '@client/event-bus'
import {openChatEvent} from '@client/events'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {Company} from '@extensions/company'
import {globals} from '@extensions/globals-base'
import {Page} from '@extensions/page'
import {PageService} from '@extensions/page-service'
import {GroupChatProxy} from '@extensions/proxies/group-chat-proxy'
import {PersonalChatProxy} from '@extensions/proxies/personal-chat-proxy'

export const goto = (type: Page): void => {
  PageService.goTo(type)
}

export const changeCompany = (id: DataObjectId): void => {
  if (!id) {
    goto('settings-account')
  } else {
    Company.setCurrent(id)
  }
}

export const gotoProject = (id: DataObjectId): void => {
  PageService.goToProject(id, globals.getCompanyId())
}

export const gotoUser = (chat: PersonalChatProxy): void => {
  void Tracking.send(TrackingEvent.leftPanelOpenDirectChat)
  EventBus.dispatch(openChatEvent(chat.chatId))
}

export const gotoGroup = (chat: GroupChatProxy): void => {
  void Tracking.send(TrackingEvent.leftPanelOpenGroupChat)
  EventBus.dispatch(openChatEvent(chat.chatId))
}
